<template>
  <ImagePick
    class="image-pick"
    :allow-paste-url="true"
    :visible="newImageDialog"
    @close="cancel"
    @change="save"
  />
</template>

<script>
import ImagePick from '@/components/shared/ImagePick.vue'

export default {
  name: 'InsertImageDialog',
  components: {
    ImagePick,
  },
  data: () => ({
    newImageDialog: false,
    resolve: null,
    reject: null,
  }),

  methods: {
    open() {
      this.newImageDialog = true
      return new Promise((resolve, reject) => {
        this.resolve = resolve
        this.reject = reject
      })
    },
    save(payload) {
      this.newImageDialog = false
      this.resolve(payload)
    },
    cancel() {
      this.newImageDialog = false
      this.resolve(false)
    },
  },
}
</script>
<style lang="less" scoped>
.image-pick {
  z-index: 100000;
}
</style>
